import { render, staticRenderFns } from "./Ruby.vue?vue&type=template&id=4569145a&"
import script from "./Ruby.vue?vue&type=script&lang=js&"
export * from "./Ruby.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports